import { render, staticRenderFns } from "./DictionariesPicture.vue?vue&type=template&id=78a9f518&scoped=true&"
import script from "./DictionariesPicture.vue?vue&type=script&lang=js&"
export * from "./DictionariesPicture.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesPicture.vue?vue&type=style&index=0&id=78a9f518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a9f518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
